import {GameObject, HelperFunctions, IVector2} from "../../tsthree";
import {Container, NineSlicePlane, Sprite, Texture} from "pixi.js";
import {buttonify} from "../../engine/HelperFunctions/buttonify";
import {tsthreeConfig} from "../../config/tsthreeConfig";

export class ScrollBar extends GameObject {

    public update: (_maxIncrements: number) => void;
    private _onScroll: (_increment: number) => void;

    public scrollWheel(_increments: number): void {
        this._onScroll(_increments);
    }

    constructor(
        settings: {
            height: number;
            onScroll: (_currIncrements: number) => void;
        }
    ) {
        super("ScrollBar");

        let currIncrements = 0;
        let maxIncrements = 0;
        const scrollBgContainer = new Container();
        for(let i = 0; i < (Math.ceil(settings.height / 16) - 1); i++) {
            const scrollBg = new Sprite(
                ENGINE.getPIXIResource("checkerboard-nineslice") as Texture,
            );
            scrollBg.position.set(-scrollBg.width, (16 * i) + 3);
            scrollBgContainer.addChild(scrollBg);
        }
        scrollBgContainer.cacheAsBitmap = true;
        this.addChild(scrollBgContainer);

        const upArrow = new Sprite(
            ENGINE.getPIXIResource("up-arrow") as Texture,
        );
        upArrow.anchor.set(1, 0);
        this.addChild(upArrow);

        const downArrow = new Sprite(
            ENGINE.getPIXIResource("down-arrow") as Texture,
        );
        downArrow.anchor.set(1, 1);
        downArrow.position.set(0, settings.height + 3);
        this.addChild(downArrow);

        const scrollBarNineslice = new NineSlicePlane(
            ENGINE.getPIXIResource("generic-square-nineslice") as Texture
        );
        const nineSliceMaxHeight = settings.height - 16 - 16 + 4;
        scrollBarNineslice.height = nineSliceMaxHeight;
        scrollBarNineslice.position.set(
            -scrollBarNineslice.width,
            16
        );
        this.addChild(scrollBarNineslice);

        this._onScroll = (_increment: number) => {
            if(maxIncrements <= 0) {
                return;
            }
            currIncrements =
                Math.min(Math.max(
                    currIncrements + _increment, 0
                ), maxIncrements);
            settings.onScroll(currIncrements);

            const min = 16;
            const max = (nineSliceMaxHeight + 16) - scrollBarNineslice.height;
            const delta = max - min;
            const final = delta * (currIncrements / maxIncrements);

            scrollBarNineslice.position.set(
                scrollBarNineslice.position.x,
                16 + final
            );
        };
        buttonify(downArrow, {
            onFire: () => {
                this._onScroll(1);
            }
        });
        buttonify(upArrow, {
            onFire: () => {
                this._onScroll(-1);
            }
        });
        let pointerDown = false;
        let lastPos: IVector2 = null;
        let currIncrementsCache: number = 0;
        const onPointerUp = () => {
            pointerDown = false;
            lastPos = null;
            currIncrementsCache = 0;
        };
        buttonify(scrollBarNineslice, {
            trackMovementOutsideElement: true,
            onFire: () => {
            },
            onPointerUp: onPointerUp,
            onPointerDown: (ev) => {
                pointerDown = true;
                if(!lastPos) {
                    currIncrementsCache = currIncrements;
                    lastPos = HelperFunctions.parseInteractionEvent(ev);
                }
            },
            onPointerMove: (ev) => {
                if(!pointerDown) return;
                const currPos = HelperFunctions.parseInteractionEvent(ev);
                if(currPos.x >= tsthreeConfig.width || currPos.x < 0) {
                    onPointerUp();
                    return;
                }
                // currIncrements = scrollBarNineslice.position
                // currIncrements = currIncrementsCache + (Math.round(
                //         (currPos.y - lastPos.y) / (
                //             settings.height / maxIncrements
                //         ))
                // );
                // console.log(`(currPos.y - lastPos.y) = ${(currPos.y - lastPos.y)}`);
                // console.log(`maxIncrements = ${maxIncrements}`);
                // console.log(currIncrements);


                const min = 16;
                const max = (nineSliceMaxHeight + 16) - scrollBarNineslice.height;
                const delta = max - min;
                const final = delta * (currIncrements / maxIncrements);

                // scrollBarNineslice.position.set(
                //     scrollBarNineslice.position.x,
                //     16 + final
                // );
                currIncrements = currIncrementsCache + (Math.round(
                        (currPos.y - lastPos.y) / (
                            delta / maxIncrements
                        ))
                );

                this._onScroll(0);
            },
        });

        this.update = (_maxIncrements) => {
            maxIncrements = _maxIncrements;
            scrollBarNineslice.height = Math.max(nineSliceMaxHeight * (
                1 - (_maxIncrements * 0.05)
            ), 16);
            scrollBarNineslice.position.set(
                scrollBarNineslice.position.x,
                16
            );
        };
    }
}